import React from "react";
import { API, Auth } from "aws-amplify";
import classnames from 'classnames';
import { Field, Formik } from "formik";
import moment, { formatDate, parseDate } from 'moment';
import { Alert, Badge, Button, Card, Table } from 'react-bootstrap';
import DayPicker, { DateUtils } from 'react-day-picker';
import { Locations } from "../../components/contstants/Locations";

import '../registration/RegistrationForm.css';

const InputFeedback = ({ error }) =>
    error ? <div className="input-feedback">{error}</div> : null;

const RadioButton = ({
    field: { name, value, onChange, onBlur },
    id,
    label,
    className,
    ...props
}) => (
    <div>
        <input
            name={name}
            id={id}
            type="radio"
            value={id}
            checked={id === value}
            onChange={onChange}
            onBlur={onBlur}
            className={classnames("radio-button")}
            {...props}
        />
        <label htmlFor={id}>{label}</label>
    </div>
);

const RadioButtonGroup = ({ value, error, touched, id, label, className, children }) => {
    const classes = classnames(
        "input-field",
        {
            "is-success": value || (!error && touched),
            "is-error": !!error
        },
        className
    );
    return (
        <div className={classes}>
            <fieldset>
                <legend>{label}</legend>
                {children}
                {touched && <InputFeedback error={error} />}
            </fieldset>
        </div>
    );
};

export default class RoadTestDates extends React.Component {
    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.state = {
            selectedDays: [],
            loading: false,
            showToast: false,
            toastType: "Warning",
            toastMesssage: "",
            roadTestDates: {},
            locations: Locations
        };
    }

    componentDidMount() {
        const that = this;
        fetch('https://s3.amazonaws.com/publicdates/roadTestDates.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'GET'
        })
            .then(this.handleErrors)
            .then(function (response) {
                return response.json();
            }).then(function (data) {
                data = JSON.parse(data);
                if (data !== null) {
                    var selectedDays = Object.keys(data).map(x => new Date(x));
                    that.setState({ selectedDays: selectedDays, roadTestDates: data });
                }
            });
    }

    handleSubmit = async event => {
        this.setState({ showToast: false, toastMesssage: "" });
        const that = this;
        let newRoadTestDates = {};
        let roadTestDates = this.state.roadTestDates;
        let selectedDays = this.state.selectedDays.map(x => x.toISOString());
        let newValidDates = Object.keys(roadTestDates).filter(x => selectedDays.includes(x));
        newValidDates.forEach(date => {
            newRoadTestDates[date] = roadTestDates[date];
        });
        let session = await Auth.currentSession();
        let options = {
            body: newRoadTestDates,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': session.idToken.jwtToken
            }
        };
        this.setState({ loading: true });
        API.post("APIGateway", "/updateroadtestdates", options)
            .then(function (data) {
                that.setState({ loading: false, showToast: true, toastType: "Success", toastMesssage: "Successfully updated!" });
            }).catch(function (error) {
                console.log(error);
                if (error.response.status === 401) {
                    that.setState({ loading: false, showToast: true, toastType: "Warning", toastMesssage: "Authentication Failed. Please log back in." });
                } else {
                    that.setState({ loading: false, showToast: true, toastType: "Warning", toastMesssage: "There was an error saving your dates. Please copy this message and send it to your developer for debugging." + JSON.stringify(error.response) });
                }
            });
    };

    addLocation = (date, location) => {
        var roadTestDates = this.state.roadTestDates;
        if (!location.includes("RMV") && !location.includes("Braintree - Granite St")) {
            let dayOfWeek = moment(date).day();
            if (dayOfWeek >= 2 && dayOfWeek <= 5) {
                date = moment(date).isoWeekday(1).toISOString();
            }
        }
        if (!roadTestDates[date]) {
            roadTestDates[date] = {};
        }
        if (!roadTestDates[date].locations) {
            roadTestDates[date].locations = [];
        }
        roadTestDates[date].locations.push(location);
        roadTestDates[date].locations = [...new Set(roadTestDates[date].locations)].sort();
        this.setState({ roadTestDates });
    };

    subtractLocation = (date, location) => {
        var roadTestDates = this.state.roadTestDates;
        roadTestDates[date].locations = roadTestDates[date].locations.filter(x => x !== location);
        if (roadTestDates[date].locations && roadTestDates[date].locations.length === 0) {
            delete roadTestDates[date];
        }
        this.setState({ roadTestDates });
    };

    handleDayClick(day, { selected }) {
        this.setState({ refreshStatus: "", dateError: "" });
        const { selectedDays } = this.state;
        if (selected) {
            const selectedIndex = selectedDays.findIndex(selectedDay =>
                DateUtils.isSameDay(selectedDay, day)
            );
            selectedDays.splice(selectedIndex, 1);
        } else {
            let dayOfWeek = moment(day).day();
            if (dayOfWeek === 0) {
                day = moment(day).subtract(1, "day").startOf('day').toDate();
            }
            if (dayOfWeek >= 2 && dayOfWeek <= 5) {
                day = moment(day).toDate();
            }
            const selectedIndex = selectedDays.findIndex(selectedDay =>
                DateUtils.isSameDay(selectedDay, day)
            );
            if (selectedIndex === -1) {
                day = moment(day).startOf('day').toDate();
                selectedDays.push(day);
            }
        }
        this.setState({ selectedDays });
    }

    render() {
        const { showToast, toastMesssage, toastType } = this.state;

        return (
            <div className="holder">
                {/* Toast notification */}
                {showToast && (
                    <Alert
                        variant={toastType === "Success" ? "success" : "warning"}
                        onClose={() => this.setState({ showToast: false })}
                        dismissible
                        style={{ position: 'fixed', top: 0, right: 0, zIndex: 1050, width: "40%" }}
                    >
                        <Alert.Heading>{toastType}</Alert.Heading>
                        {toastMesssage}
                    </Alert>
                )}

                {/* Page header */}
                <div style={{ marginBottom: "1.25rem" }}>
                    <h3 style={{ marginBottom: "0.25rem" }}>Select Active Dates</h3>
                    <small className="text-muted">Click dates on the calendar to mark them as active road test days, then assign locations.</small>
                </div>

                {/* Calendar */}
                <Card style={{ display: "inline-block", marginBottom: "1.5rem" }}>
                    <Card.Body style={{ padding: "0.75rem" }}>
                        <DayPicker
                            selectedDays={this.state.selectedDays}
                            onDayClick={this.handleDayClick}
                            formatDate={formatDate}
                            parseDate={parseDate}
                            numberOfMonths={2}
                        />
                    </Card.Body>
                </Card>

                {/* Date / location table */}
                <Card style={{ marginBottom: "1.5rem" }}>
                    <Card.Header>
                        <strong>Assign Locations</strong>
                        {this.state.selectedDays.length > 0 && (
                            <Badge variant="secondary" style={{ marginLeft: "0.5rem" }}>
                                {this.state.selectedDays.length} date{this.state.selectedDays.length === 1 ? "" : "s"}
                            </Badge>
                        )}
                    </Card.Header>
                    <Card.Body style={{ padding: 0 }}>
                        {this.state.selectedDays.length === 0 ? (
                            <p className="text-muted" style={{ padding: "1rem", margin: 0 }}>
                                No dates selected. Click days on the calendar above to get started.
                            </p>
                        ) : (
                            <Table striped bordered hover size="sm" style={{ margin: 0 }}>
                                <thead className="thead-dark">
                                    <tr>
                                        <th style={{ whiteSpace: "nowrap" }}>Date</th>
                                        <th>Type</th>
                                        <th>Locations</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.selectedDays
                                        .sort((a, b) => a - b)
                                        .map((date) => {
                                            const parsedDate = date.toISOString();
                                            const longDate = moment(date).format("ddd, MMMM Do YYYY");
                                            const dayOfWeek = moment(date).day();
                                            const isWeekend = dayOfWeek === 6 || dayOfWeek === 1;
                                            let selectedLocations = [];
                                            if (this.state.roadTestDates[parsedDate] && this.state.roadTestDates[parsedDate].locations) {
                                                selectedLocations = this.state.roadTestDates[parsedDate].locations;
                                            }

                                            const availableLocations = this.state.locations.filter(location => {
                                                if (isWeekend) return true;
                                                return location.includes("RMV") || location.includes("Braintree - Granite St");
                                            });

                                            return (
                                                <tr key={parsedDate}>
                                                    <td style={{ whiteSpace: "nowrap" }}>{longDate}</td>
                                                    <td>
                                                        <Badge pill variant={isWeekend ? "primary" : "info"}>
                                                            {isWeekend ? "Weekend" : "Weekday"}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.25rem 1rem" }}>
                                                            {availableLocations.map(location => (
                                                                <div key={location} className="form-check" style={{ margin: 0 }}>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={parsedDate + location}
                                                                        checked={selectedLocations.includes(location)}
                                                                        onChange={() =>
                                                                            selectedLocations.includes(location)
                                                                                ? this.subtractLocation(parsedDate, location)
                                                                                : this.addLocation(parsedDate, location)
                                                                        }
                                                                    />
                                                                    <label className="form-check-label" htmlFor={parsedDate + location}>
                                                                        {location}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>

                {/* Save */}
                <div style={{ marginBottom: "1.5rem" }}>
                    <Button variant="primary" disabled={this.state.loading} onClick={this.handleSubmit}>
                        {this.state.loading ? "Saving…" : "Save Dates"}
                    </Button>
                </div>

                {/* Form preview */}
                <Card>
                    <Card.Header><strong>Public Form Preview</strong></Card.Header>
                    <Card.Body>
                        <p className="text-muted" style={{ marginBottom: "0.5rem" }}>
                            Shows how dates appear on the registration form (dates within 12 days are hidden).
                        </p>
                        <Formik initialValues={{}} onSubmit={this.bindSubmitForm}>
                            {props => {
                                const { values, touched, errors, handleSubmit, setFieldValue, setFieldTouched } = props;
                                return (
                                    <form onSubmit={handleSubmit}>
                                        <RadioButtonGroup
                                            id="roadTestDateOption"
                                            label="Preferred Date (Subject to RMV availability)"
                                            value={values.roadTestDateOption}
                                            error={errors.roadTestDateOption}
                                            touched={touched.roadTestDateOption}
                                            onChange={setFieldValue}
                                            onBlur={setFieldTouched}
                                        >
                                            {this.state.selectedDays
                                                .filter(x => moment(x).add(5, 'hours').subtract(12, 'days').isAfter(moment()))
                                                .sort((a, b) => a - b)
                                                .map(roadTestDate => {
                                                    const parsedDate = roadTestDate.toISOString();
                                                    let locations = [];
                                                    if (this.state.roadTestDates[parsedDate] && this.state.roadTestDates[parsedDate].locations) {
                                                        locations = this.state.roadTestDates[parsedDate].locations;
                                                    }
                                                    if (roadTestDate.getDay() === 6) {
                                                        return locations.map((location, key) => (
                                                            <Field
                                                                key={roadTestDate + location + key}
                                                                component={RadioButton}
                                                                name="roadTestDateOption"
                                                                id={roadTestDate.toISOString()}
                                                                label={" Weekend of " + moment(roadTestDate).format('M/D') + " (Sat-Sun) at " + location}
                                                            />
                                                        ));
                                                    } else {
                                                        return locations.map((location, key) => (
                                                            <Field
                                                                key={roadTestDate + location + key}
                                                                component={RadioButton}
                                                                name="roadTestDateOption"
                                                                id={roadTestDate.toISOString()}
                                                                label={
                                                                    location.includes("RMV")
                                                                        ? "Weekday of " + moment(roadTestDate).format('M/D (ddd)') + " at " + location
                                                                        : "Week of " + moment(roadTestDate).isoWeekday(1).format('M/D') + " - " + moment(roadTestDate).isoWeekday(5).format('M/D') + " (Mon-Fri) at " + location + " (Exact date tbd)"
                                                                }
                                                            />
                                                        ));
                                                    }
                                                })}
                                        </RadioButtonGroup>
                                    </form>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}
